import styled from "styled-components";

import { colors } from "../../../../constants/colors";

export type StyledListHeaderItemProps = {
  width: string;
};

export const StyledListHeaderItem = styled.div<StyledListHeaderItemProps>`
  width: ${({ width }) => width};
  text-align: center;
  border-bottom: solid 1px ${colors.lightGray};
  margin: 0px 5px 10px 5px;
  padding-bottom: 10px;
`;
